import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{
    availableReportTypes: string;
  }>()
  .create(({ theme, availableReportTypes }) => ({
    reportsGrid: {
      display: 'grid',
      height: '100%',
      gap: '1.5rem',
      gridTemplateColumns: '1fr',
      width: '100%',
      ...(availableReportTypes === 'DEFAULT' && {
        gridTemplateRows: 'repeat(2, minmax(8rem, 1fr))'
      }),
      ...(availableReportTypes === 'DEFAULT_AND_EDR_OR_VMP' && {
        gridTemplateRows: 'repeat(3, minmax(8rem, 1fr))'
      }),
      ...(availableReportTypes === 'DEFAULT_AND_EDR_AND_VMP' && {
        gridTemplateRows: 'repeat(4, minmax(8rem, 1fr))'
      }),
      [theme.breakpoints.up('lg')]: {
        ...(availableReportTypes === 'DEFAULT' && {
          gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
          gridTemplateRows: 'repeat(1, minmax(8rem, 1fr))'
        }),
        ...(availableReportTypes === 'DEFAULT_AND_EDR_OR_VMP' && {
          gridTemplateColumns: 'repeat(1, minmax(0, 1fr))',
          gridTemplateRows: 'repeat(3, minmax(8rem, 1fr))'
        }),
        ...(availableReportTypes === 'DEFAULT_AND_EDR_AND_VMP' && {
          gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
          gridTemplateRows: 'repeat(2, minmax(8rem, 1fr))'
        })
      },
      [theme.breakpoints.up('xl')]: {
        ...(availableReportTypes === 'DEFAULT_AND_EDR_OR_VMP' && {
          gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
          gridTemplateRows: 'repeat(1, minmax(8rem, 1fr))'
        })
      }
    },
    reportsGridSection: {
      [theme.breakpoints.up('lg')]: {
        ...(availableReportTypes === 'DEFAULT' && {
          gridColumn: 'span 1',
          gridRow: 'span 2'
        }),
        ...(availableReportTypes === 'DEFAULT_AND_EDR_OR_VMP' && {
          gridColumn: 'span 1',
          gridRow: 'span 1'
        }),
        ...(availableReportTypes === 'DEFAULT_AND_EDR_AND_VMP' && {
          gridColumn: 'span 1',
          gridRow: 'span 1'
        })
      },
      [theme.breakpoints.up('xl')]: {
        ...(availableReportTypes === 'DEFAULT_AND_EDR_OR_VMP' && {
          gridColumn: 'span 1',
          gridRow: 'span 1'
        })
      }
    }
  }));

export default useStyles;
